import { customElement, property, state } from 'lit/decorators.js'
import { CSSResultGroup, html, LitElement } from 'lit'
import { consume } from '@lit/context'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { productTileIndexContext, productTileProductContext } from 'components/discovery/product/tile-parts/tile-product-context.js'
import { InternalProduct, ProductModel } from 'components/discovery/product/tile-parts/tile-parts-typing.js'
import { partsStyle } from 'components/discovery/product/tile-parts/tile-parts.style.js'
import { orderTemplateQuantity, orderTemplateTrackingContext } from 'components/discovery/product/add-to-order-templates/order-template-payload.js'
import type { OrderTemplateLoginRequiredEvent } from 'components/discovery/product/add-to-order-templates/components/order-template-slide-in/order-template-slide-in.js'
import 'components/discovery/product/add-to-order-templates/components/order-template-slide-in/order-template-slide-in.js'
import { style } from './tile-add-to-order-template.style.js'

/**
 * @deprecated Use the `csc-order-template-slide-in` tile-config widget type instead.
 */
@customElement('csc-product-tile-add-to-order-template')
export class CSCProductTileAddToOrderTemplate extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, partsStyle, style]

  @consume({ context: productTileProductContext })
  @state()
  product: InternalProduct = new ProductModel().parseToInternal()

  @consume({ context: productTileIndexContext, subscribe: true })
  @state()
  private tileIndex?: number

  @property({ type: String, attribute: 'icon-name' })
  iconName: string = 'star'

  @property({ type: String })
  variant: string = 'primary'

  @property({ type: Boolean, attribute: 'as-link' })
  asLink = false

  @property({ type: Boolean, attribute: 'use-login-slide-in' })
  useLoginSlideIn = false

  private handleLoginRequired(event: OrderTemplateLoginRequiredEvent) {
    if (this.useLoginSlideIn) return
    event.preventDefault()
    document.querySelector('#login-sidebar')?.dispatchEvent(new CustomEvent('openSidebar', {
      detail: { productId: this.product.id },
      bubbles: true,
      composed: true,
    }))
  }

  override render() {
    return html`
      <csc-order-template-slide-in
        .trackingProduct="${this.product}"
        product-id="${this.product.id}"
        quantity="${orderTemplateQuantity(this.product)}"
        .trackingContext="${orderTemplateTrackingContext(this.tileIndex)}"
        trigger-type="${this.asLink ? 'link' : 'icon-button'}"
        trigger-variant="${this.variant}"
        trigger-icon-name="${this.iconName}"
        @csc-order-template-login-required="${this.handleLoginRequired}"
      ></csc-order-template-slide-in>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-product-tile-add-to-order-template': CSCProductTileAddToOrderTemplate
  }
}
